import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getCoachAiName } from 'utils/i18n';
import config from 'utils/config';
import { openMindsetCoachingPanel } from 'utils/mindset';
import useSearchParameter from 'hooks/useSearchParameter';
import { useFetchUserMindsetSettings } from 'actions/userProfile';
import CenterContent from 'components/CenterContent';
import CoachAiAvatar from 'components/Avatar/CoachAIAvatar';
import Flex from 'components/Flex';
import Landmark from 'components/Landmark';
import PageBackLink from 'components/PageBackLink';
import PageSection from 'components/PageSection';
import PageTitle from 'components/PageTitle';
import MindsetCard from 'components/MindsetCard';
import { HOME_ROUTE } from '../../../routes';
import ErrorScreen from '../errors/ErrorScreen';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function CoachAI() {
  return /*#__PURE__*/_jsxs(PageSection, {
    children: [/*#__PURE__*/_jsx(PageBackLink, {
      fallback: HOME_ROUTE,
      mb: "xs"
    }), /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      mb: "s",
      gap: "xs",
      children: [/*#__PURE__*/_jsx(CoachAiAvatar, {
        size: "big"
      }), /*#__PURE__*/_jsx(PageTitle, {
        size: "large",
        children: getCoachAiName()
      })]
    }), /*#__PURE__*/_jsx(MindsetCard, {})]
  });
}
function CoachAiAccessWrapper(_ref) {
  var children = _ref.children;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useFetchUserMindsetS = useFetchUserMindsetSettings(),
    hasMindsetAgent = _useFetchUserMindsetS.hasMindsetAgent,
    isLoading = _useFetchUserMindsetS.isLoading;
  // Computed directly rather than via useShowMindsetInPage so config.isTrialHub
  // short-circuits synchronously — avoids a second useFetchUserMindsetSettings call.
  var isMindsetFloating = config.isTrialHub && hasMindsetAgent;
  var _useSearchParameter = useSearchParameter('q'),
    _useSearchParameter2 = _slicedToArray(_useSearchParameter, 1),
    q = _useSearchParameter2[0];
  var _useSearchParameter3 = useSearchParameter('skillName'),
    _useSearchParameter4 = _slicedToArray(_useSearchParameter3, 1),
    skillName = _useSearchParameter4[0];
  var _useSearchParameter5 = useSearchParameter('coachingContext'),
    _useSearchParameter6 = _slicedToArray(_useSearchParameter5, 1),
    coachingContext = _useSearchParameter6[0];

  // Email buttons deep-link to /coach-ai?q=<message>&skillName=<name>&coachingContext=<prompt>.
  // When the FAB is enabled, intercept the arrival: open the panel before Navigate redirects.
  useEffect(function () {
    if (!isMindsetFloating || !q) return;
    openMindsetCoachingPanel({
      skillName: skillName ? String(skillName) : undefined,
      coachingContext: coachingContext ? String(coachingContext) : ''
    });
  }, [isMindsetFloating, q, skillName, coachingContext, t]);
  if (isMindsetFloating) {
    return /*#__PURE__*/_jsx(Navigate, {
      to: HOME_ROUTE,
      replace: true
    });
  }
  if (isLoading) {
    return /*#__PURE__*/_jsx(CenterContent, {
      fillParent: true,
      children: /*#__PURE__*/_jsx(Landmark, {
        icon: "spinner"
      })
    });
  }
  if (hasMindsetAgent) {
    return children;
  }
  return /*#__PURE__*/_jsx(ErrorScreen, {});
}
function ProtectedCoachAi() {
  return /*#__PURE__*/_jsx(CoachAiAccessWrapper, {
    children: /*#__PURE__*/_jsx(CoachAI, {})
  });
}
export default ProtectedCoachAi;